export default __webpack_public_path__ + "static/media/con_frEND02.66d4bd0f.jpg";